import type { Placement } from '@floating-ui/react'
import type { CSSProperties, FC } from 'react'
import { useState } from 'react'
import {
    CreateDataGrantModalStep,
    CreateDataGrantModalStore,
} from './modal-store'
import { observer } from 'mobx-react-lite'
import type { Stores } from '../../../../../util/store'
import { CreateDataGrantIndexModal } from './index-step'
import { CreateDataGrantConsumerModal } from './consumer-step'
import { CreateDataGrantConfirmationModal } from './confirmation-step'

export interface CreateDataGrantModalOptions {
    anchor: HTMLElement
    placement?: Placement
    onClose(): void
    style?: CSSProperties
    containerStyle?: CSSProperties
    stores: Stores
    providerOrganizationId: string
}

export const CreateDataGrantModal: FC<CreateDataGrantModalOptions> = observer(
    (props) => {
        const [store] = useState(
            () =>
                new CreateDataGrantModalStore({
                    providerOrganizationId: props.providerOrganizationId,
                    create: async (body) => {
                        await props.stores.organizationDataGrants.create(body)
                        props.onClose()
                    },
                }),
        )

        switch (store.step) {
            case CreateDataGrantModalStep.Index:
                return <CreateDataGrantIndexModal {...props} store={store} />

            case CreateDataGrantModalStep.ConsumerOrganization:
                return <CreateDataGrantConsumerModal {...props} store={store} />

            case CreateDataGrantModalStep.Confirmation:
                return (
                    <CreateDataGrantConfirmationModal
                        {...props}
                        store={store}
                    />
                )
        }
    },
)
